module.exports = __webpack_public_path__ + "img/zz13.508b64b7.png";